import React from "react"
import { useTranslation } from "react-i18next"
import PhoneInput from "react-phone-input-2"

const PhoneNumberInput = ({ field, onChange, height }) => {
  const { t } = useTranslation()

  return (
    <PhoneInput
      country={"au"}
      value={field.value}
      onChange={(phone) => onChange(phone)}
      placeholder={t("register.phoneNumberPlaceholder")}
      enableSearch
      disableSearchIcon
      inputProps={{ name: "phone" }}
      inputStyle={{
        width: "100%",
        height: height,
        backgroundColor: "white",
        border: "1px solid",
        borderColor: "inherit",
        borderRadius: "12px",
      }}
      buttonStyle={{
        borderTopLeftRadius: "12px",
        borderBottomLeftRadius: "12px",
        width: "42px",
      }}
      dropdownStyle={{ textAlign: "left" }}
    />
  )
}

export default PhoneNumberInput
